import * as Yup from 'yup'

export const setupValidationSchema = () => {
  const today = new Date()

  return (
    Yup.object().shape({
      description: Yup.string().required('A reminder description is required'),
      due_at: Yup.date()
        .required('A due date is required')
        .min(today, 'Due date must be after today'),
      remind_at: Yup.date()
        .required('A remind date is required')
        .min(today, 'Remind date must be after today')
        .max(Yup.ref('due_at'), 'Remind date must be before or on the due date')
    })
  )
}

export const initialReminderFormValues = (reminder) => {
  const today = new Date()
  const tomorrow = new Date(today.setDate(today.getDate() + 1))

  return {
    description: reminder ? reminder.description : '',
    due_at: reminder ? reminder.due_at : tomorrow,
    remind_at: reminder ? reminder.remind_at : tomorrow
  }
}
